import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  d: "M4 1.2 7 6H1z",
  fill: "currentColor"
}
const _hoisted_4 = {
  key: 1,
  d: "M4 6.8 1 2h6z",
  fill: "currentColor"
}
const _hoisted_5 = {
  key: 2,
  cx: "4",
  cy: "4",
  r: "2.2",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 3,
  x: "1",
  y: "3.3",
  width: "6",
  height: "1.4",
  rx: ".7",
  fill: "currentColor"
}
const _hoisted_7 = { class: "tnum" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['delta-pill', `is-${_ctx.dir}`]),
    title: _ctx.label
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      (_ctx.dir === 'up')
        ? (_openBlock(), _createElementBlock("path", _hoisted_3))
        : (_ctx.dir === 'down')
          ? (_openBlock(), _createElementBlock("path", _hoisted_4))
          : (_ctx.dir === 'new')
            ? (_openBlock(), _createElementBlock("circle", _hoisted_5))
            : (_openBlock(), _createElementBlock("rect", _hoisted_6))
    ])),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.text), 1)
  ], 10, _hoisted_1))
}